import { MSerializers } from "@legacy-megarax/serializers";

export const customerStatuses = ["vip", "verified", "unverified", "inactive"] as const;
export type CustomerStatus = (typeof customerStatuses)[number];
export const customerStatusSerializer = MSerializers.stringOneOf(...customerStatuses);
